import { SaveDataOrchestrator } from '@mental-mint/shared-utils';
import { GameId } from '@mental-mint/shared-types';
import { CraftegrySaveData, DEFAULT_CRAFTEGORY_SAVE_DATA, CRAFTEGORY_SAVE_VERSION } from '../types/SaveData';

export const loadCraftegory = async (): Promise<CraftegrySaveData> => {
  const saveObject = await SaveDataOrchestrator.loadGameData<CraftegrySaveData>(GameId.Craftegory);
  const data = saveObject?.savedGameData;
  // Reset on version mismatch to avoid stale schema issues (e.g. old unlockedTermNames)
  if (!data || data.version !== CRAFTEGORY_SAVE_VERSION) {
    return DEFAULT_CRAFTEGORY_SAVE_DATA;
  }
  return data;
};

export const saveCraftegory = async (data: CraftegrySaveData): Promise<void> => {
  await SaveDataOrchestrator.saveGameData(GameId.Craftegory, data);
};
